import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SearchField from "../../../shared/SearchField";
import CustomTable from "../../../shared/CustomTable";
import {
  dummyWriteOffData,
  WriteOffColumns,
} from "../../../constants/InverntoryConstants";
import { useTranslation } from "react-i18next";
import Button from "../../../shared/CustomButton";
import ReusableModal from "../../../shared/ReuseableModal";
import AddWriteOffList from "./AddWriteOffList";
import { addWriteOff } from "../../../redux/slices/WriteOffSlice";
function WriteOffList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const writeOffData = useSelector((state) => state.writeOff?.writeOffData || dummyWriteOffData);
  const [openAddWriteOff, setOpenAddWriteOff] = useState(false);

  const handleAddWriteOff = (newData) => {
    // Format date to YYYY-MM-DD format
    const formatDate = (date) => {
      if (date instanceof Date) {
        return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
      }
      if (typeof date === 'string' && date) {
        const dateObj = new Date(date);
        return dateObj.toISOString().split('T')[0];
      }
      return new Date().toISOString().split('T')[0]; // Default to today
    };

    const newWriteOff = {
      id: writeOffData.length + 1,
      item_name: newData.itemName || "New Item",
      write_off_qty: newData.quantity,
      write_off_date: formatDate(newData.writeOffDate),
      rate: newData.rate,
      total_amount: newData.totalAmount,
      remark: newData.remarks,
      warehouse: newData.warehouse,
      approver: newData.approver,
      writeOffType: newData.writeOffType,
      reason: newData.reason,
    };
    
    // Dispatch to Redux store
    dispatch(addWriteOff(newWriteOff));
    setOpenAddWriteOff(false);
  };
  return (
    <><div>
      <div className="flex flex-wrap justify-between items-center gap-4 w-full">
        <SearchField
          className="w-full sm:w-[300px]"
          placeholder={t("Search")} />
        <div>
          <Button className="!px-4 !py-1 !text-sm !mt-4"
            onClick={() => setOpenAddWriteOff(true)}
          >
            {t("Add Write Off")}
          </Button>
        </div>
      </div><div className="mt-4">
        <CustomTable columns={WriteOffColumns(t)} data={writeOffData} />
      </div><ReusableModal
        title={t("Add Write Off")}
        isVisible={openAddWriteOff}
        onClose={() => setOpenAddWriteOff(false)}
        size="md"
      >
        <AddWriteOffList 
          onClose={() => setOpenAddWriteOff(false)} 
          onSubmit={handleAddWriteOff} 
        />
      </ReusableModal>
    </div>
      </>
  );
}

export default WriteOffList;
